module.exports = __webpack_public_path__ + "static/media/top-selling-icon.d9da7884.svg";